export default __webpack_public_path__ + "static/media/no-suitcase.2a8005f5.svg";